import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { config } from '@/config'
import { service } from '@/service'
import { fixProductTaxons, fixTaxon, fixProduct } from '@/service/upgradeService'

export default {
	namespaced: true,
	state: {
    products: [],
    categories: []
	},
	actions: {
    async loadCategories({ commit, rootState }, { accumulatorGroup = null } = {}) {
      let basketToken = null;
			let shippingCode = null;
      let channel = null;

			if (rootState.productlist.menuMode) {
				channel = rootState.productlist.menuChannel ?? config.DEFAULT_CHANNEL
				shippingCode = config.MENU_SHIPPING_CODE;
			} else if (rootState.cart.serverData) {
				channel = rootState.cart.serverData.channel.code
				basketToken = rootState.cart.basketToken
			} else {
				channel = config.DEFAULT_CHANNEL
			}

      try {
				const result = await service.menuChildTaxons({ channel, taxons: true, tokenValue: basketToken, shippingCode, accumulatorGroup, deliverTime: rootState.productlist.menuTimedAvailability ? formatServerSimple(dayjs()) : null })
        commit('setCategories', { item: result.taxons.map(taxon => fixTaxon(taxon)) })
      }
      catch(err) {
				commit('setCategories', {item: []})
			}
    },
    async loadProducts({ commit, rootState }, { accumulatorGroup = null } = {}) {

      let basketToken = null;
			let shippingCode = null;
      let channel = null;

			if (rootState.productlist.menuMode) {
				channel = rootState.productlist.menuChannel ?? config.DEFAULT_CHANNEL
				shippingCode = config.MENU_SHIPPING_CODE;
			} else if (rootState.cart.serverData) {
				channel = rootState.cart.serverData.channel.code
				basketToken = rootState.cart.basketToken
			} else {
				channel = config.DEFAULT_CHANNEL
			}



      try {
        const result = await service.menuChildTaxons({ channel, products: true, tokenValue: basketToken, shippingCode, accumulatorGroup, deliverTime: rootState.productlist.menuTimedAvailability ? formatServerSimple(dayjs()) : null })

        const products = Object.values(result?.products)
          .filter(item => item.variants?.length)
          .map(item => {
            item = fixProduct(item)
            return {
              code: item.code,
              name: item.variants[0].name,
              description: item.description,
              shortDescription: item.shortDescription,
              images: item.images,
              image: item.image,
              imageMood: item.imageMood,
              id: item.id,
              price: item.variants[0].price,
              originalPrice: item.variants[0].originalPrice,
              discountInPercent: item.discountInPercent,
              taxons: item.taxons,
              availableInTaxons: item.availableInTaxons ? item.availableInTaxons.map(taxon => taxon.code) : [],
            }
          })
        commit('setProducts', { item: products })
      }
      catch(err) {
				commit('setProducts', {item: []})
			}
    },
    setCategories({ commit }, { categories }) {
      commit('setCategories', { item: categories })
    },
		async adjustChildProducts({ dispatch, state, getters, rootState }, { item, childCodes }) {
			if (item?.children) {
				return await dispatch('cart/replaceCartItemChildren', { identifier: item.id, childCodes }, { root: true })
			} else {
				config.DEBUG && console.warn("childprodcuts: this item has no children, should not happen", item)
			}
		},
	},
	getters: {
    childProducts(state, getters, rootState, rootGetters) {
      if (rootGetters['productlist/useMenu']) {
        return state.products || []
      }
			return rootState.cart.serverData
				? rootState.cart.serverData.availableChildProducts
					.reduce((a, item) => {
						if (typeof item !== 'object') {
							item = rootState.cart.productMap[item]
						}

            if (item.variants?.length) {
              let newItem = {
                code: item.code,
                name: item.variants[0].name,
                description: item.description,
                shortDescription: item.shortDescription,
                images: item.images,
                image: item.image,
                imageMood: item.imageMood,
                id: item.id,
                price: item.variants[0].price,
                originalPrice: item.variants[0].originalPrice,
                discountInPercent: item.discountInPercent,
                taxons: item.taxons,
                availableInTaxons: item.availableInTaxons ? item.availableInTaxons.map(taxon => taxon.code) : [],
              }
              a.push(fixProductTaxons(newItem))
            }

            return a
					}, [])
				: []
		},
		childProductCategories(state, getters, rootState, rootGetters) {
      if (rootGetters['productlist/useMenu']) {
        return state.categories || []
      }
			return rootState.cart.serverData
        ? rootState.cart.serverData.childProductsCategories
          .map(category => ({
            ...category,
            name: category.title,
            childType: category.type,
            code: category.taxon
          }))
        : []
		},
		childProductsByType(state, getters, rootState, rootGetters) {
			const categories = getters.childProductCategories;
			const products = getters.childProducts;
      const isMenu = !!rootGetters['productlist/useMenu']

			const types = {
				option: [],
				extra: [],
			};

			categories.forEach(category => {
				if (!Array.isArray(types[category.childType])) {
					types[category.childType] = [];
				}
				types[category.childType].push({
					...category,
					products: products.filter(v => isMenu ? category.products?.includes?.(v.code) : v.taxons.includes(category.taxon))
				});
			});

			return types;
		}
	},
	mutations: {
    setProducts: generateSetChild('products'),
    setCategories: generateSetChild('categories'),
	}
}
